export default __webpack_public_path__ + "static/media/ethereal-collage.d62ba115.webp";